import { Capacitor } from '@capacitor/core';

export class AppTrackingService {
  private static hasPermission = false;
  private static isInitialized = false;
  
  /**
   * Initialize ATT listener for iOS
   */
  static init(): Promise<boolean> {
    return new Promise((resolve) => {
      if (this.isInitialized) {
        resolve(this.hasPermission);
        return;
      }

      if (Capacitor.getPlatform() !== 'ios') {
        // Non-iOS platforms - allow tracking
        this.hasPermission = true;
        this.isInitialized = true;
        console.log('Non-iOS platform, allowing tracking by default');
        resolve(true);
        return;
      }

      // Listen for ATT status from native layer
      const handleATTStatus = (event: any) => {
        const enabled = event.detail?.enabled || false;
        this.hasPermission = enabled;
        this.isInitialized = true;
        
        console.log('ATT permission received:', enabled);
        resolve(enabled);
        
        // Remove listener after first response
        window.removeEventListener('ATTStatusUpdated', handleATTStatus);
      };

      // Add listener for native ATT response
      window.addEventListener('ATTStatusUpdated', handleATTStatus);
      
      // Fallback timeout - if no response in 3 seconds, assume no permission
      setTimeout(() => {
        if (!this.isInitialized) {
          console.warn('ATT timeout - defaulting to no permission');
          this.hasPermission = false;
          this.isInitialized = true;
          window.removeEventListener('ATTStatusUpdated', handleATTStatus);
          resolve(false);
        }
      }, 3000);
    });
  }

  /**
   * Check if we have tracking permission
   */
  static hasTrackingPermission(): boolean {
    return this.hasPermission;
  }

  /**
   * Reset permission state (for testing or debugging)
   */
  static reset(): void {
    this.hasPermission = false;
    this.isInitialized = false;
  }
} 